<script>
import Datatable from "@/router/layouts/table-datatable.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: { Datatable },
  data() {
    return {
      soalPenyusun: {
        loading: true,
        list: [],
        columns: [
          { width: "30%", label: "Status Soal", name: "-" },
          { width: "17%", label: "Pilihan Ganda", name: "-" },
          { width: "17%", label: "Benar Salah", name: "-" },
          { width: "18%", label: "Menjodohkan", name: "-" },
          { width: "18%", label: "Text", name: "-" },
        ],
        chart: { options: {}, series: [], labels: [] },
      },
    };
  },

  mounted() {
    this.fetchSoalPenyusun();
  },

  methods: {
    async fetchSoalPenyusun() {
      this.soalPenyusun.loading = true;
      await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "dashboard/soal-penyusun",
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      }).then((res) => {
        if (res.data.meta.code != 200) {
          Swal.fire({ icon: "error", title: "Gagal get data soal penyusun" });
          return;
        }
        this.soalPenyusun.list = res.data.data.list;
        this.soalPenyusun.chart.series = res.data.data.series;
        this.soalPenyusun.chart.labels = res.data.data.label;
        this.soalPenyusun.loading = false;
        this.setSoalPenyusunChart();
      });
    },

    setSoalPenyusunChart() {
      this.soalPenyusun.chart.options = {
        chart: { type: "bar" },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        title: { text: "Jumlah Soal Penyusun per Status dan Tipe" },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        xaxis: {
          categories: this.soalPenyusun.chart.labels,
          title: { text: "Status Soal" },
        },
        yaxis: { title: { text: "Jumlah Soal" } },
        fill: { opacity: 1 },
        legend: { position: "top" },
        tooltip: { y: { formatter: (val) => val + " soal" } },
      };
    },
  },
};
</script>

<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Soal Penyusun per Status dan Tipe</div>
            <datatable :columns="soalPenyusun.columns">
              <tbody>
                <tr v-if="soalPenyusun.loading">
                  <td colspan="99" class="text-center">
                    <i class="fas fa-spinner fa-spin"></i> Loading
                  </td>
                </tr>
                <tr v-else-if="soalPenyusun.list.length < 1">
                  <td colspan="99" class="text-center">Data tidak tersedia</td>
                </tr>
                <tr v-else v-for="(row, key) in soalPenyusun.list" :key="key">
                  <td>{{ row.status }}</td>
                  <td class="text-center">{{ row.pg }}</td>
                  <td class="text-center">{{ row.bs }}</td>
                  <td class="text-center">{{ row.mtc }}</td>
                  <td class="text-center">{{ row.txt }}</td>
                </tr>
              </tbody>
            </datatable>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <apexchart
              v-if="soalPenyusun.chart.series.length > 0"
              class="apex-charts"
              :options="soalPenyusun.chart.options"
              :series="soalPenyusun.chart.series"
            />
            <div v-else-if="!soalPenyusun.loading" class="text-center py-4 text-muted">
              Tidak ada data untuk ditampilkan pada grafik.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
